import { render, staticRenderFns } from "./NotificationOutcomeTag.vue?vue&type=template&id=11b3f3a0&scoped=true&"
import script from "./NotificationOutcomeTag.vue?vue&type=script&lang=js&"
export * from "./NotificationOutcomeTag.vue?vue&type=script&lang=js&"
import style0 from "./NotificationOutcomeTag.vue?vue&type=style&index=0&id=11b3f3a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b3f3a0",
  null
  
)

export default component.exports